import { createContext } from 'react';
export const ModalContext = createContext({
    open: false,
    onClose: undefined,
    toggleZenMode: undefined,
});
//# sourceMappingURL=Context.js.map